import aboutBusiness from './aboutBusiness';
import aboutYou from './aboutYou';
import alreadyRegistered from './alreadyRegistered';
import footer from './footer';
import fullSignatoryPage from './fullSignatoryPage';
import idvWrapper from './idvWrapper';
import idvHardFailure from './idvHardFailure';
import idvErrorPage from './idvErrorPage';
import mayfairAccountError from './mayfairAccountError';
import mobileNumberMissing from './mobileNumberMissing';
import redirect from './redirect';
import registrationApproval from './registrationApproval';
import registrationInProgress from './registrationInProgress';
import sessionTimedOut from './sessionTimedOut';
import smsOtp from './smsOtp';
import smsOtpAuthorise from './smsOtpAuthorise';
import submitYourRegistration from './submitYourRegistration';
import switchToMobile from './switchToMobile';
import technicalErrorPage from './technicalErrorPage';
import thankYou from './thankYou';
import threeStepsToRegisterApproval from './threeStepsToRegisterApproval';
import threeStepsToRegisterDelegateAccess from './threeStepsToRegisterDelegateAccess';
import threeStepsToRegisterDesktop from './threeStepsToRegisterDesktop';
import threeStepsToRegisterIdVerify from './threeStepsToRegisterIdVerify';
import triageDeviceSwitch from './triageDeviceSwitch';
import triageStartPage from './triageStartPage';
import unableToVerify from './unableToVerify';
import { AppContent } from '../AppContent';

const content: AppContent = {
  footer,
  triageStartPage,
  fullSignatoryPage,
  redirect,
  registrationApproval,
  triageDeviceSwitch,
  threeStepsToRegisterDelegateAccess,
  threeStepsToRegisterApproval,
  threeStepsToRegisterDesktop,
  aboutBusiness,
  switchToMobile,
  mayfairAccountError,
  aboutYou,
  mobileNumberMissing,
  alreadyRegistered,
  technicalErrorPage,
  registrationInProgress,
  smsOtp,
  smsOtpAuthorise,
  sessionTimedOut,
  unableToVerify,
  submitYourRegistration,
  thankYou,
  idvWrapper,
  idvHardFailure,
  threeStepsToRegisterIdVerify,
  idvErrorPage,
};

export default content;
